
export const checkRole = (allowRoles: number[], userRoles: number[]) => {
  return allowRoles.some(role => userRoles.includes(role))
}